/* eslint-disable no-plusplus */
import React from 'react';

import mediaQuery from '../../../../helpers/mediaQuery';
import useResizeListener from '../../../../hooks/useResizeListener';
import { LayoutTypes, ZoomedImage } from '../../../../types';
import ZoomerGallery from './ZoomerGallery';
import MediaElement from './MediaElement';

const { viewerMediaSet, imageLayouts = [] } = window.globalProductDetails;

interface Layout {
  layoutType: LayoutTypes;
  mediaIndexes: number[];
}

function prepareLayouts(layouts: LayoutTypes[]): Layout[] {
  let index = 0;

  return layouts.map((layout) => {
    if (layout === LayoutTypes.IMAGE_PER_ROW) {
      return {
        layoutType: layout,
        mediaIndexes: [index++]
      };
    }

    return {
      layoutType: layout,
      mediaIndexes: [index++, index++]
    };
  });
}

const layouts = prepareLayouts(imageLayouts);

function MediaGallery(): React.ReactElement | null {
  const { innerWidth } = useResizeListener();
  const isMediumUp = React.useMemo(mediaQuery.isMediumUp, [innerWidth]);
  const [zoomedImage, setZoomedImage] = React.useState<ZoomedImage | undefined>(undefined);

  if (!isMediumUp) {
    return null;
  }

  if (zoomedImage) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }

  return (
    <>
      {zoomedImage && <ZoomerGallery zoomedImage={zoomedImage} setZoomedImage={setZoomedImage} />}
      {viewerMediaSet &&
        layouts.map(({ layoutType, mediaIndexes }, index) => {
          const customClassname = index === 0 ? 'hide-for-small' : '';

          if (layoutType === LayoutTypes.IMAGE_PER_ROW) {
            return (
              <div className={`row ${customClassname}`} key={`layout_${index + 1}`}>
                <div className="columns small-12 large-6 media-gallery__item-wrapper large-push-3">
                  <MediaElement
                    index={mediaIndexes[0]}
                    media={viewerMediaSet.items[mediaIndexes[0]]}
                    className="gallery-desktop"
                    setZoomedImage={setZoomedImage}
                  />
                </div>
              </div>
            );
          }

          if (layoutType === LayoutTypes.TWO_IMAGES_PER_ROW) {
            return (
              <div className={`row ${customClassname}`} key={`layout_${index + 1}`}>
                <div className="columns small-12 large-6 media-gallery__item-wrapper">
                  <MediaElement
                    index={mediaIndexes[0]}
                    media={viewerMediaSet.items[mediaIndexes[0]]}
                    className="gallery-desktop"
                    setZoomedImage={setZoomedImage}
                  />
                </div>
                <div className={`columns small-12 large-6 media-gallery__item-wrapper ${customClassname}`}>
                  <MediaElement
                    index={mediaIndexes[1]}
                    media={viewerMediaSet.items[mediaIndexes[1]]}
                    className="gallery-desktop"
                    setZoomedImage={setZoomedImage}
                    autoplay
                  />
                </div>
              </div>
            );
          }

          return null;
        })}
    </>
  );
}

export default MediaGallery;
